module.exports = __webpack_public_path__ + "img/PT76.7702ffd9.png";